import React from 'react';
import { Helmet } from 'react-helmet';
import HeroSectionImage from '../../images/CorporateSolutionsPage/HH25_CorporateSolutions_HeroBackground.png';
import DiffIcon from '../../images/CorporateSolutionsPage/HH25_CorporateSolutions_DiffIcon.svg';
import Section3Image from '../../images/CorporateSolutionsPage/HH25_CorporateSolutions_Section3_Background.png';
import HowItWorksIcon from '../../images/CorporateSolutionsPage/HH25_CorporateSolutions_HowItWorksIcon.svg';
import HowItWorksStep1 from '../../images/CorporateSolutionsPage/HH25_CorporateSolutions_HowItWorksIcon_Step1.svg';
import HowItWorksStep2 from '../../images/CorporateSolutionsPage/HH25_CorporateSolutions_HowItWorksIcon_Step2.svg';
import HowItWorksStep3 from '../../images/CorporateSolutionsPage/HH25_CorporateSolutions_HowItWorksIcon_Step3.svg';
import HowItWorksWoman from '../../images/CorporateSolutionsPage/HH25_CorporateSolutions_HowItWorksIcon.svg';
import Section5Image from '../../images/CorporateSolutionsPage/HH25_CorporateSolutions_Section5_Background.png';

const CorporateSolutionsPage = () => {
  return (
    <div className="corporate-solutions-page-container">
      <Helmet>
        <title>HappyHome - Soluciones Corporativas</title>
        <meta name="description" content="Soluciones corporativas de limpieza y mantenimiento para empresas e instituciones que exigen excelencia." />
        <meta name="keywords" content="corporativo, limpieza, mantenimiento, empresas, excelencia" />
        <meta property="og:title" content="HappyHome - Soluciones Corporativas" />
        <meta property="og:description" content="Soluciones corporativas de limpieza y mantenimiento para empresas e instituciones que exigen excelencia." />
        <meta property="og:image" content={HeroSectionImage} />
        <meta property="og:url" content="http://www.happyhome.com.ar" />
      </Helmet>
      <section className="corporate-corp-hero-section">
        <div className="corporate-corp-hero-bg-image">
          <img src={HeroSectionImage} alt="Soluciones Corporativas" />
          <div className="container-max-width">
            <div className="corporate-corp-hero-titles">
              <h1 className="corporate-corp-hero-main-title">
                Soluciones <span className="corporate-corp-hero-main-title-underline">corporativas</span>
              </h1>
              <div className="corporate-corp-hero-quote">
                "Ofrecemos <em>servicios de contratación y</em> gestión de personal de limpieza y mantenimiento, diseñados para empresas e instituciones <em>que exigen excelencia</em>."
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="corporate-corp-diff-section">
        <div className="corporate-corp-diff-content">
          <div className="corporate-corp-diff-left">
            <div className="corporate-corp-diff-icon">
              <img src={DiffIcon} alt="Diferencial" />
            </div>
            <div className="corporate-corp-diff-title">NUESTRO DIFERENCIAL:</div>
            <div className="corporate-corp-diff-main">
              UNA DE LAS BASES DE DATOS MÁS IMPORTANTES DE ARGENTINA<br />
              + UN ENFOQUE HUMANO REAL
            </div>
          </div>
          <div className="corporate-corp-diff-right">
            <p>
              En <strong className="coral">Happy Home Corporate</strong>, contamos con una de las bases de datos de personal más completas del país en perfiles operativos de limpieza y mantenimiento.
            </p>
            <p>
              <strong className="coral">Reclutamos y potenciamos a los mejores talentos del mercado</strong>, porque creemos que cada contratación es una oportunidad para transformar una empresa. Ofrecemos un servicio altamente personalizado, con atención individualizada a cada cliente y seguimiento cercano en todo el proceso.
            </p>
            <ul className="corporate-corp-diff-list">
              <li>
                <span className="yellow">Te enviamos la</span> cantidad exacta de perfiles <span className="yellow">que necesitás, filtrados y listos para entrevistar.</span>
              </li>
              <li>
                <span className="yellow">Nos diferenciamos por el trato directo, la agilidad de respuesta y un</span> compromiso real con los resultados concretos.
              </li>
            </ul>
          </div>
        </div>
      </section>
      {/* Nueva sección: ¿Qué hacemos? */}
      <section className="corp-whatwedo-section">
        <div className="corp-whatwedo-bg" style={{ backgroundImage: `url(${Section3Image})`, backgroundSize: 'cover', backgroundPosition: 'center' }}>
          <h2 className="corp-whatwedo-title">
            ¿Qué hacemos?
          </h2>
          <div className="corp-whatwedo-cards-row">
            <div className="corp-whatwedo-card corp-whatwedo-card-coral">
              {/* SVG flecha izquierda (placeholder) */}
              <div className="corp-whatwedo-arrow corp-whatwedo-arrow-left">{/* SVG flecha izquierda aquí */}</div>
              <div className="corp-whatwedo-card-content">
                <div className="corp-whatwedo-card-title">Talent Matching</div>
                <div className="corp-whatwedo-card-desc">
                  Encontramos el match perfecto entre candidatos y empresas. Analizamos tus necesidades y filtramos perfiles con precisión. Nos enfocamos en resultados concretos y un servicio profesional, humano y eficiente.
                </div>
              </div>
            </div>
            <div className="corp-whatwedo-card corp-whatwedo-card-yellow">
              <div className="corp-whatwedo-card-content">
                <div className="corp-whatwedo-card-title">Staff Placement</div>
                <div className="corp-whatwedo-card-desc">
                  Te acercamos personal operativo para Limpieza o mantenimiento general. En Happy Home Corporate contamos con una de las bases de datos más completas del país con más de 2.500 trabajadores activos.
                </div>
              </div>
            </div>
            <div className="corp-whatwedo-card corp-whatwedo-card-coral">
              <div className="corp-whatwedo-card-content">
                <div className="corp-whatwedo-card-title">Employer Support</div>
                <div className="corp-whatwedo-card-desc">
                  Capacitamos a tu equipo con workshops presenciales y capacitaciones online on-demand para mejorar desempeño y retención.
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Sección: How It Works (idéntica a la imagen) */}
      <section className="corp-howitworks-section">
        <div className="corp-howitworks-cols">
          <div className="corp-howitworks-col-left">
            <img src={HowItWorksWoman} alt="Cómo funciona - mujer" className="corp-howitworks-woman" />
          </div>
          <div className="corp-howitworks-col-right">
            <h2 className="corp-howitworks-title">¿Cómo funciona<br />el proceso?</h2>
            <div className="corp-howitworks-steps">
              <div className="corp-howitworks-step-row">
                <img src={HowItWorksStep1} alt="Paso 1" className="corp-howitworks-step-icon" />
                <div>
                  <span className="corp-howitworks-step-desc">
                    NOS CONTACTÁS POR WHATSAPP O COMPLETÁS EL FORMULARIO.<br />
                    <strong>TE RESPONDEMOS EN MENOS DE 48 HS.</strong>
                  </span>
                </div>
              </div>
              <div className="corp-howitworks-step-row">
                <img src={HowItWorksStep2} alt="Paso 2" className="corp-howitworks-step-icon" />
                <div>
                  <span className="corp-howitworks-step-desc">
                    CONFIRMÁS CUÁNTAS PERSONAS NECESITÁS, EL PERFIL QUE BUSCÁS,<br />
                    <strong>Y TE ENVIAMOS UN PRESUPUESTO PERSONALIZADO.</strong>
                  </span>
                </div>
              </div>
              <div className="corp-howitworks-step-row">
                <img src={HowItWorksStep3} alt="Paso 3" className="corp-howitworks-step-icon" />
                <div>
                  <span className="corp-howitworks-step-desc">
                    <strong>TE ENVIAMOS LOS PERFILES MÁS CALIFICADOS</strong>, LISTOS PARA ENTREVISTAR.<br />
                    VAS A PODER COMUNICARTE DIRECTAMENTE CON CADA UNO.
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="corp-section5">
        <div className="corp-section5-bg" style={{ backgroundImage: `url(${Section5Image})` }}></div>
        <div className="corp-section5-content">
          <div className="corp-section5-col left">
            <div className="corp-section5-title-block">
              <div className="corp-section5-col-title main">
                PAGÁS <span className="italic">menos</span>
              </div>
              <div className="corp-section5-col-title main">
                CONTRATÁS <span className="italic">mejor</span>
              </div>
            </div>
          </div>
          <div className="corp-section5-col right">
            <div className="corp-section5-col-text">
              Ofrecemos soluciones integrales adaptadas a cada organización.
              Sin comisiones ocultas. Sin complicaciones.

              A diferencia de las consultoras tradicionales, no cobramos un sueldo por perfil contratado. Ofrecemos un valor fijo y accesible por cada perfil enviado, mucho más bajo que el promedio del mercado.

              Valor aproximado: $100.000 por perfil,
              según cantidad de puestos, tipo de búsqueda y urgencia.
            </div>
          </div>
        </div>
      </section>
      <div className="corp-section5-bottom-border"></div>
      {/* Sección de contacto corporativo */}
      <section className="corp-contact-section">
        <div className="corp-contact-cols">
          <div className="corp-contact-col-left">
            <h2 className="corp-contact-title">¿QUERÉS QUE TE CONTACTEMOS?</h2>
            <div className="corp-contact-desc-row">
              <span className="corp-contact-arrow">→</span>
              <div className="corp-contact-desc">
                Completá el siguiente formulario<br />
                y nos pondremos en contacto con vos a la brevedad<br />
                para conocer mejor tus necesidades y contarte<br />
                cómo podemos ayudarte.
              </div>
            </div>
          </div>
          <div className="corp-contact-col-right">
            <div className="corp-contact-form-mockup">
              <div className="corp-contact-form-row">
                <label>Nombre de la persona de contacto</label>
                <div className="corp-contact-input-mock" />
              </div>
              <div className="corp-contact-form-row corp-contact-form-row-2col">
                <div>
                  <label>Razón social de la empresa</label>
                  <div className="corp-contact-input-mock" />
                </div>
                <div>
                  <label>Correo electrónico</label>
                  <div className="corp-contact-input-mock" />
                </div>
              </div>
              <div className="corp-contact-form-row">
                <label>Contanos qué necesitás o cualquier información adicional que quieras compartir</label>
                <div className="corp-contact-textarea-mock" />
              </div>
              <div className="corp-contact-form-row corp-contact-form-row-btn">
                <button className="corp-contact-btn-mock" disabled>Enviar formulario</button>
              </div>
            </div>
            <div className="corp-contact-extra">
              <div><span className="corp-contact-arrow">→</span> También podés escribirnos a <a href="mailto:info@happyhome.com.ar">info@happyhome.com.ar</a></div>
              <div><span className="corp-contact-arrow">→</span> O dejarnos un mensaje por <a href="https://wa.me/">Whatsapp</a></div>
            </div>
          </div>
        </div>
      </section>
      <div className="corp-contact-bottom-border"></div>
    </div>
  );
};

export default CorporateSolutionsPage;